import { render, staticRenderFns } from "./Aufgabe.vue?vue&type=template&id=2efc8f78&"
import script from "./Aufgabe.vue?vue&type=script&lang=ts&"
export * from "./Aufgabe.vue?vue&type=script&lang=ts&"
import style0 from "./Aufgabe.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports